<template>
    <vx-card class="card-area" id="loader">
        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                <div class="vx-row header-title mb-4">
                    <h1>Нагрузка на SSP</h1>
                </div>
            </vs-col>
        </vs-row>

        <vs-table :data="sspLoadList" max-items="10" pagination class="mt-5">
            <template slot="thead">
                <vs-th>
                    Id
                </vs-th>
                <vs-th>
                    Название SSP
                </vs-th>
                <vs-th>
                    Процент нагрузки
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{tr.sspTypeId}}</vs-td>
                    <vs-td>{{tr.sspTypeName}}</vs-td>
                    <vs-td>
                        <v-select :options="dicts.loadValues" @input="loadValueChanged(tr)" label="name" class="w-full" :clearable=false
                            v-model="tr.loadValue">
                        </v-select>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <sweet-modal ref="toggleChangeLoadModal" hide-close-button icon="error" title="Изменение процента нагрузки на SSP">
            <div class="mb-5">Вы действительно хотите изменить процент нагрузки на SSP?</div>

            <vs-button class="mr-2" color="danger" @click="changeLoadValue()" type="filled">
                Изменить
            </vs-button>
            <vs-button class="mr-2" color="primary" @click="cancelLoadValueChange()" type="filled">
                Отменить
            </vs-button>
        </sweet-modal>
    </vx-card>
</template>


<script>
    import vSelect from 'vue-select'
    import axios from 'axios'
    import {
        SweetModal,
        SweetModalTab
    } from 'sweet-modal-vue'

    export default {
        name: 'sspLoad',
        data() {
            return {
                sspLoadList: [],
                selected: null,
                dicts: {
                    loadValues: []
                }
            }
        },
        components: {
            vSelect,
            SweetModal,
            SweetModalTab
        },
        methods: {
            loadSspList() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.axios.all([
                        this.axios.get('load/ssp'),
                        this.axios.get('load/dicts')
                    ])
                    .then(axios.spread((sspLoadList, dicts) => {
                        this.sspLoadList = sspLoadList.data;
                        this.dicts.loadValues = dicts.data.loadValues;
                        this.sspLoadList.forEach(ssp => { 
                            let dictLoadValue = this.dicts.loadValues.find(v => v.value == ssp.loadValue);     
                            ssp.loadValue = { id: dictLoadValue.value, name: dictLoadValue.name }
                        });
                    }))
                    .catch((err) => {
                        this.$vs.notify({
                            title: "Ошибка!",
                            text: "Ошибка при загрузке списка SSP.",
                            color: "danger",
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                    });
            },
            loadValueChanged(ssp) {
                this.selected = ssp;
                this.$refs.toggleChangeLoadModal.open();
            },
            cancelLoadValueChange() {
                this.$refs.toggleChangeLoadModal.close();
                this.loadSspList();
            },
            changeLoadValue() {
                this.$refs.toggleChangeLoadModal.close();

                const ssp = this.selected;
                const params = {
                    sspTypeId: ssp.sspTypeId,
                    loadValue: ssp.loadValue.value
                };
                this.$axios({
                    method: 'PUT',
                    url: 'load/ssp/' + ssp.sspTypeId,
                    params: params,
                    errors: this.errors,
                    success: (response) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Процент успешно обновлен",
                            color: "success",
                        });
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        if (err.request.status == 422 && err.data.errors['']) {
                            const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: "Внимание!",
                                text: error,
                                color: "danger",
                            });
                        }

                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при обновлении процента нагрузки!",
                            color: "danger",
                        });
                    }
                })
            }
        },
        mounted() {
            this.loadSspList();
        }
    }
</script>

<style lang="scss">
    table {
        tr.selected {
            cursor: text !important;
        }
    }

    thead {
        th {
            font-size: 15px !important;

            .sort-th {
                i {
                    font-size: 19px;
                }
            }
        }
    }

    .header-title {
        flex-direction: column;
    }

    .vs-con-table .vs-con-tbody, .vs-table--content {
        overflow: initial;
    }

    .vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
        // z-index: 200;
        -webkit-transform: none;
    }
</style>